import { render, staticRenderFns } from "./BGAS.vue?vue&type=template&id=45b7f70d&scoped=true&"
import script from "./BGAS.vue?vue&type=script&lang=js&"
export * from "./BGAS.vue?vue&type=script&lang=js&"
import style0 from "./BGAS.vue?vue&type=style&index=0&id=45b7f70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7f70d",
  null
  
)

export default component.exports